export const HEADER_ROW_HEIGHT = 32;
export const ROW_HEIGHT = 35;

export interface ISearchCriteria {
  searchTerm: string;
  isMaster: boolean;
}

export const enum RecordType {
  Account = 'Account',
  Symbol = 'Symbol'
}

export interface Record {
  accountName: string;
}

export interface AccountRecord extends Record {
  accountId: string;
  type?: string;
  titleLine2?: string;
  titleLine3?: string;
}

export interface ISearchResponse {
  data?: Array<AccountRecord>;
}
